import { getPublicRuntimeConfig } from "./runtime-config";
export const getUserRoles = (idToken, customerId) => {
    const { DTN_PRODUCT_CODE } = getPublicRuntimeConfig();
    if (DTN_PRODUCT_CODE !== undefined) {
        const appInfoClaim = idToken["https://auth.dtn.com/appInfo"];
        const appInfo = appInfoClaim[DTN_PRODUCT_CODE];
        if (appInfo) {
            if ("customers" in appInfo) {
                let [customer] = appInfo.customers;
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                if (customerId !== undefined && customerId !== "unknown") {
                    customer = appInfo.customers.find((c) => c.customerId === customerId);
                }
                return (customer === null || customer === void 0 ? void 0 : customer.roles) ? customer.roles : [];
            }
            return appInfo.roles;
        }
    }
    return [];
};
